import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

const StepAddProject = () => {
  const { t } = useTranslation();
  return (
    <>
      <h2 className='mb-6 mb-md-8'>{t('onboarding_add_project_title')}</h2>
      <p className='mb-0'>
        <Trans i18nKey='onboarding_add_project_desc' />
      </p>
    </>
  );
};

export default StepAddProject;
